import React, { Component } from "react";

export default class THEOPlayer extends Component {
  shouldComponentUpdate() {
    return false;
  }

  divMounted(el) {
    if (el == null) {
      return;
    }

    const player = new window.THEOplayer.Player(el, {
      libraryLocation: "/THEOplayer/"
    });

    player.source = {
      sources: [
        {
          src: this.props.manifestURL,
          type: "application/x-mpegurl"
        }
      ]
    };

    player.addEventListener("timeupdate", () => {
      this.props.timeUpdateCallback(player.currentTime * 1000);
    });
  }

  render() {
    return (
      <div
        style={{ width: "100%" }}
        className="theoplayer-skin video-js"
        ref={this.divMounted.bind(this)}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/VOD/Players/THEOplayer.js